import config from "../config";

// Active Storage's `url_for(...)` (used by the backend jbuilders) serializes
// icons as ABSOLUTE redirect URLs, e.g.
//   https://<host>/rails/active_storage/blobs/redirect/<signed_id>/x.png
// The app historically did `config.REACT_APP_ROOT_URL + icon`, which is only
// correct for RELATIVE paths. Prepending the root to an already-absolute URL
// yields "https://hosthttps://host/..." → a broken <img>. (It "worked" in
// prod only because REACT_APP_ROOT_URL is empty there; locally it points at
// the prod host, so every icon double-prefixes and breaks.)
//
// Resolve robustly: pass absolute / protocol-relative / data URLs through
// untouched; prepend the root host only to relative paths.
export const resolveIconUrl = (raw) => {
  if (!raw || typeof raw !== "string") return "";
  if (/^https?:\/\//i.test(raw) || raw.startsWith("//") || raw.startsWith("data:")) {
    return raw;
  }
  return `${config.REACT_APP_ROOT_URL || ""}${raw}`;
};
